import { render, staticRenderFns } from "./correspondence.vue?vue&type=template&id=5b10dff2&"
import script from "./correspondence.vue?vue&type=script&lang=js&"
export * from "./correspondence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports